import { render, staticRenderFns } from "./SelectProjectStatuses.vue?vue&type=template&id=6552d6ac"
import script from "./SelectProjectStatuses.vue?vue&type=script&lang=js"
export * from "./SelectProjectStatuses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports